// Scripts inseridos via innerHTML não executam: recria cada <script> do snippet configurado no admin.
export function injectChatWidget(snippet?: string | null) {
  if (!snippet?.trim() || document.querySelector('script[data-chat-widget]')) return;

  const parsed = new DOMParser().parseFromString(snippet, 'text/html');
  parsed.querySelectorAll('script').forEach((source) => {
    const script = document.createElement('script');
    Array.from(source.attributes).forEach(({ name, value }) => script.setAttribute(name, value));
    script.text = source.text;
    script.dataset.chatWidget = 'true';
    document.body.appendChild(script);
  });
}
